export const GET_JOB_REQUEST_BY_ID = 'GET_JOB_REQUEST_BY_ID'

export const GET_JOB_SUCCESS_BY_ID = 'GET_JOB_SUCCESS_BY_ID'

export const GET_JOB_FAILURE_BY_ID = 'GET_JOB_FAILURE_BY_ID'

export const GET_JOB_REQUEST_BY_JOB = 'GET_JOB_REQUEST_BY_JOB'

export const GET_JOB_SUCCESS_BY_JOB = 'GET_JOB_SUCCESS_BY_JOB'

export const GET_JOB_FAILURE_BY_JOB = 'GET_JOB_FAILURE_BY_JOB'

export const GET_JOB_REQUEST_BY_JOB_5 = 'GET_JOB_REQUEST_BY_JOB_5'

export const GET_JOB_SUCCESS_BY_JOB_5 = 'GET_JOB_SUCCESS_BY_JOB_5'

export const GET_JOB_FAILURE_BY_JOB_5 = 'GET_JOB_FAILURE_BY_JOB_5'